import { useRef, useCallback } from "react";

export const useScreenShare = ({ videoSenderRef }) => {
  const screenTrackRef = useRef(null);
  const cameraTrackRef = useRef(null);

  const startScreenShare = useCallback(async () => {
    if (!videoSenderRef.current) return;

    const stream = await navigator.mediaDevices.getDisplayMedia({
      video: true,
    });

    const screenTrack = stream.getVideoTracks()[0];
    screenTrackRef.current = screenTrack;

    cameraTrackRef.current = videoSenderRef.current.track;

    await videoSenderRef.current.replaceTrack(screenTrack);

    // User clicks "Stop sharing"
    screenTrack.onended = () => {
      stopScreenShare();
    };
  }, []);

  const stopScreenShare = useCallback(async () => {
    if (!videoSenderRef.current || !cameraTrackRef.current) return;

    await videoSenderRef.current.replaceTrack(cameraTrackRef.current);

    screenTrackRef.current?.stop();
    screenTrackRef.current = null;
  }, []);

  return {
    startScreenShare,
    stopScreenShare,
    isScreenSharing: !!screenTrackRef.current,
  };
};
